//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { formatDate } from '../../../src/lib/date';
import util from '@/lib/util';
import moment from 'moment';

export default {
    name: "my-activeDetail",
    components: {},
    filters: {
        formatDate(time, type) {
            if (type === 1) {
                return moment(time).format('YYYY-MM-DD');
            }
            return moment(time).format('YYYY-MM-DD HH:mm');
        }
    },
    data() {
        return {
            id: 0,
            activity: {
                jumpUrl: ''
            },
            signUpInfo: {},
            downloadUrl: util.ApiUrl + 'file/download/',
        };
    },
    methods: {
        certificate() {
            this.$router.push({ path: '/certificate' })
        },
        getSignUp() {
            abp.ajax.get('/api/services/app/Activity/GetSignUpRecordById?recordId=' + this.id).then(res => {
                this.signUpInfo = {};
                this.signUpInfo = res.data.result;
                this.getActivity(this.signUpInfo.activityId)
            });
        },
        getActivity(id) {
            let vm = this;
            this.$store.dispatch({
                type: 'activity/GetActivityById',
                id: id
            }).then(() => {
                vm.activity = vm.$store.state.activity.activityInfo;
            })
        },
        onClicked() {
            if (this.activity.jumpUrl && this.activity.jumpUrl.startsWith('http')) {
                window.open(this.activity.jumpUrl, '_blank');
            } else {
                window.open('http://' + this.activity.jumpUrl, '_blank');
            }
        },
    },
    created() {
        this.id = parseInt(this.$route.params.id) || 0;
        if (this.id > 0) {
            this.getSignUp();
        }
    }
}
